import { Card } from "@mui/material";
import { ReactNode } from "react";

type TProps = {
    children: ReactNode;
    filled?: boolean;
};

export default function DiscountCardPercentageBox({
    children,
    filled = false,
}: TProps) {
    return (
        <Card
            sx={{
                width: 60,
                height: 60,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: filled && "#0E4571",
                border: filled && "none",
                color: filled && "white",
            }}
        >
            {children}
        </Card>
    );
}
